module.exports = __webpack_public_path__ + "static/3-6608526262827c128c80ad160eac54b2.svg";